import { Badge } from '@/components/ui/badge';

import { useCallDetail } from '@/context/CallProvider';

const SENTIMENT_VARIANT: Record<string, 'success' | 'secondary' | 'fail'> = {
  POSITIVE: 'success',
  NEUTRAL: 'secondary',
  NEGATIVE: 'fail',
};

export const CallSentiment = () => {
  const { call: callDetail } = useCallDetail();

  const sentiment = callDetail.sentiment;

  return (
    <div className="relative flex-1 h-full min-h-0">
      <div className="absolute left-0 right-0 bottom-0 h-8 pointer-events-none bg-gradient-to-b from-transparent to-white dark:to-zinc-900 z-10" />
      <div className="flex-1 h-full min-h-0 overflow-y-scroll px-4 pb-16 pt-0">
        {sentiment ? (
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <Badge variant={SENTIMENT_VARIANT[sentiment.label] ?? 'secondary'}>
                {sentiment.label}
              </Badge>
              {typeof sentiment.score === 'number' && (
                <span className="text-sm text-muted-foreground">
                  Score: {sentiment.score.toFixed(2)}
                </span>
              )}
            </div>

            {sentiment.rationale && (
              <div className="space-y-1">
                <div className="text-xs text-muted-foreground">Rationale</div>
                <p className="text-sm leading-relaxed">{sentiment.rationale}</p>
              </div>
            )}
          </div>
        ) : (
          <div className="text-sm text-muted-foreground">Not analyzed.</div>
        )}
      </div>
    </div>
  );
};
